import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "../../css/Blog/blog.css";
import "../../css/Blog/main.css";
import "../../css/Blog/style.scss";
import translations from '../../text/get-started-translations.json';
import language from '../../utils/LanguageSettings';
import { fetchBlog } from "../functions/fetchBlog";
import BlogBannerArticles from './Blog/BlogBannerArticles';
import FilteredArticles from './Blog/FilteredArticles';
import BlogHotArticles from './Blog/BlogHotArticles';
import BlogDownloadNowTV from './Blog/BlogDownloadNowTV';
import RenderSnA from '../functions/renderSnA';
import { getLocalizedData } from '../functions/getLocalizedData';

const BlogPage: React.FC = () => {
  const pageTranslations = translations[language];
  const [blogData, setBlogData] = useState<any>(null);
  const [activeGerne, setActiveGerne] = useState<any>('all');
  const [filteredGerneArticles, setFilteredGerneArticles] = useState<any>(null);
  const [seo, setSeo] = useState<any>(null);
  const [ga, setGa] = useState<any>(null);
  const articlesPerPage = 12;

  const handleGenreFilterClick = (genre: string) => {
    setActiveGerne(genre);
    const filteredGerneArticles = genre === 'all' ? blogData.articles : blogData.articles.filter((article: any) => article.attributes?.Genre?.Genre?.includes(genre));
    setFilteredGerneArticles(filteredGerneArticles);
  };

  useEffect(() => {
    const initialize = async () => {
      const data = await fetchBlog(language);
      if (data) {
        setBlogData({
          genreFilter: data.data.attributes.GenreFilter.Genre,
          articles: data.data.attributes.Articles,
          hotArticles: data.data.attributes.HotArticles,
          bannerArticles: data.data.attributes.BannerArticles,
          filterPageCategories: data.data.attributes.FilterPageCategories.Categories,
          filterPageKeywords: data.data.attributes.FilterPageKeywords,
        });
        setFilteredGerneArticles(data.data.attributes.Articles);
        setSeo(data.data.attributes.SEO || null);
        setGa(data.data.attributes.GA || null);
      }
    };
    initialize();
  }, []);

  return (
    <>
      {blogData && (
        <>
          <RenderSnA seo={seo} ga={ga} />
          <div className="blog-wrapper">
            {/* banner articles */}
            <BlogBannerArticles bannerArticles={blogData.bannerArticles} />

            {/* filter buttons */}
            <div className="filter-buttons-wrapper">
              <div className="container d-flex justify-content-center">
                <button type="button" className={`btn${activeGerne === 'all' ? ' active' : ''}`} data-genre="all" onClick={() => handleGenreFilterClick('all')}>{pageTranslations.all}</button>
                {blogData.genreFilter.map((genre: any) => (
                  <button key={genre} type="button" className={`btn${activeGerne === genre ? ' active' : ''}`} data-genre={genre} onClick={() => handleGenreFilterClick(genre)}>{getLocalizedData(genre, language)}</button>
                ))}
              </div>
            </div>

            {/* filter articles */}
            <FilteredArticles
              filteredArticles={filteredGerneArticles ? filteredGerneArticles : []}
              articlesPerPage={articlesPerPage}
              type={`blog_${activeGerne}`}
            />

            {/* hot articles */}
            <BlogHotArticles hotArticles={blogData.hotArticles} />

            {/* download now tv */}
            <BlogDownloadNowTV />
          </div>
        </>
      )}
    </>

  );
};

export default BlogPage;
